"use client"

import PaperList from '@/components/papers/PaperList';


export default function PaperListPage() {
  return (
    <PaperList />
  );
}

